import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
    Table,
    Segment,
    Breadcrumb,
    Button,
    Input,
    Label,
    Icon,
    Dropdown, Form, List
} from "semantic-ui-react";
import qs from "qs";
import update from "immutability-helper";
import _ from "lodash";
import Dls from "../../lib";
import {
    fetchInventories
} from "../../actions/inventory";

import TableFilter from "../utils/tables/TableFilter";
import OrderByHeader from "../utils/tables/OrderByHeader";
import TablePagination from "../utils/tables/TablePagination";
import {api} from "../../api";

const typeOptions = [
    { key: "Inventory", text: "Inventory", value: "Inventory" },
    { key: "Service", text: "Service", value: "Service" },
    { key: "Others", text: "Others", value: "Others" }
];

const statusOptions = [
    { key: "Active", text: "Active", value: "Active" },
    { key: "Disabled", text: "Disabled", value: "Disabled" }
];

class InventoryListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            routing: {
                params: {
                    on_page: 1,
                    per_page: 15,
                    search: "",
                    filters: {
                        type: "Inventory,Service,Others",
                        status: "Active"
                    },
                    order_by: {
                        name: "asc"
                    }
                },
                path: ""
            },
            filters: {
                types: [],
                status: []
            },
            filterOpen: true,
            selectedWarehouse: 'All',
            shopifyProductId: "",
            randmarError: []
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params.params);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params.params);
    }

    setQueryParamsFromPath = path => {
        if (this.state.routing.path !== path) {
            const params = qs.parse(path);
            const { filters } = params;
            let defaultTypeFilter = [];
            let defaultStatusFilter = [];
            if (_.isObject(filters)) {
                if (filters.type) {
                    defaultTypeFilter = filters.type.split(",");
                }

                if (filters.status) {
                    defaultStatusFilter = filters.status.split(",");
                }
            }

            this.setState({
                routing: { params, path },
                filters: {
                    types: defaultTypeFilter,
                    status: defaultStatusFilter
                }
            }, () => {
                this.fetchRecrods();
            });
        }
    };

    fetchRecrods = () => {
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchInventories(jwt, qs.stringify(params)).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    }

    runSearch = () => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: 1 }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    routeTo = () => {
        this.props.history.push(`/inventories/${qs.stringify(this.state.routing.params)}`);
    }

    _onTableHeaderSort = (field, value) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    order_by: {
                        [field]: {$set: value}
                    }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    _handleKeyPress = e => {
        if (e.key === "Enter") {
            this.runSearch();
        }
    };

    _onSearchChange = e => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    search: { $set: e.target.value }
                })
            }
        });
    };

    _onTypeDropdownSelectChange = (e, data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                types: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        type: {$set: value.join()}
                    }
                }
            })
        })
    };

    _onStatusDropdownSelectChange = (e, data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                status: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        status: {$set: value.join()}
                    }
                }
            })
        })
    };

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    getInstock = (i) => {
        const {selectedWarehouse} = this.state;
        if (selectedWarehouse === 'All') {
            if (!i.qty_total_instock) {
                return 0;
            }
            return i.qty_total_instock.instock;
        } else {
            const {qty_warehouse_instock} = i;
            let instock = 0;
            if (_.isArray(qty_warehouse_instock)) {
                _.each(qty_warehouse_instock, instockRecord => {
                    if (_.toInteger(selectedWarehouse) === _.toInteger(instockRecord.warehouse_id)) {
                        instock = _.toInteger(instockRecord.instock);
                    }
                });
            }

            return instock;
        }
    }

    getReserved = (i) => {
        const {selectedWarehouse} = this.state;
        if (selectedWarehouse === 'All') {
            if (!i.qty_total_reserved) {
                return 0;
            }
            return Math.abs(i.qty_total_reserved.reserve);
        } else {
            const {qty_warehouse_reserved} = i;
            let reserved = 0;
            if (_.isArray(qty_warehouse_reserved)) {
                _.each(qty_warehouse_reserved, reservedRecord => {
                    if (_.toInteger(selectedWarehouse) === _.toInteger(reservedRecord.warehouse_id)) {
                        reserved = Math.abs(_.toInteger(reservedRecord.reserve));
                    }
                });
            }
            return reserved;
        }
    }

    getAvailable = (i) => {
        const instock = this.getInstock(i);
        const reserved = this.getReserved(i);
        return parseInt(instock) - parseInt(reserved);
    }

    onWarehouseSelected = (value) => {
        this.setState({
            selectedWarehouse: value
        })
    }

    onImportRandmarClick = () => {
        if (this.state.shopifyProductId) {
            this.setState({
                loading: true,
                randmarError: []
            });
            api.inventory.importRandmar(this.props.jwt, this.state.shopifyProductId).then(res => {
                console.log(res.data)
                this.setState({
                    loading: false,
                    randmarError: res.data.data
                });
            }).catch(err => {
                console.log(err.response.data)
                this.setState({
                    loading: false,
                    randmarError: ["Cannot find this ID in Shopify, please check your input."]
                });
            })
        }
    }

    render() {
        const {list, warehouses} = this.props;
        let warehousesListWithAll = _.cloneDeep(warehouses);
        warehousesListWithAll.unshift({
            key: 'All',
            text: 'All Warehouses',
            value: 'All'
        });
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                <Link
                                    to={`/inventories/${Dls.pagination.inventories()}`}
                                >
                                    Inventory List
                                </Link>
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">
                        <div style={{ float: "right" }}>
                            <Button size="mini" color="teal" icon as={Link} to='/inventories/new/edit'>
                                <Icon name="barcode" />&nbsp;
                                Create
                            </Button>
                            <Button size="mini" color="teal" icon>
                                <Icon name="file excel outline" />&nbsp;
                                Upload
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-12">
                        <Segment>
                            <div className="row" style={{marginBottom: '5px'}}>
                                <div className="col-md-1">
                                    <Label as='a' color='teal' pointing='right' style={{marginTop: '5px'}}>
                                        Warehouse
                                    </Label>
                                </div>
                                <div className="col-md-5">
                                    <Dropdown
                                        value={this.state.selectedWarehouse}
                                        onChange={(e, {value}) => this.onWarehouseSelected(value)}
                                        fluid selection options={warehousesListWithAll} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                <Input
                                    placeholder="Search SKU, name or UPC and press enter"
                                    size="mini"
                                    action
                                    onKeyPress={this._handleKeyPress}
                                    onChange={this._onSearchChange}
                                    value={this.state.routing.params.search}
                                    fluid
                                >
                                    <input />
                                    <Button
                                        icon="filter"
                                        onClick={() => {this.runSearch()}}
                                        type="button"
                                        color="pink"
                                    />
                                </Input>
                            </div>
                            </div>
                            <div className="col-md-12">
                            <div className="row">
                                <div
                                    className="col-md-6"
                                        style={{ marginTop: "5px" }}
                                    >
                                    <TableFilter
                                        name="Type"
                                        options={typeOptions}
                                        selectedValues={
                                            this.state.filters.types
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onTypeDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by inventory type"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6" style={{ marginTop: "5px" }}>
                                    <TableFilter
                                        name="Status"
                                        options={statusOptions}
                                        selectedValues={
                                            this.state.filters.status
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onStatusDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by inventory status"
                                    />
                                </div>
                            </div>
                            </div>
                        </Segment>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Type</Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName="SKU"
                                            currentValue={
                                                (!_.isEmpty(this.state.routing.params.order_by.sku))
                                                    ? this.state.routing.params
                                                          .order_by.sku
                                                    : ""
                                            }
                                            field="sku"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName="Name"
                                            currentValue={
                                                (!_.isEmpty(this.state.routing.params.order_by.name))
                                                    ? this.state.routing.params
                                                          .order_by.name
                                                    : ""
                                            }
                                            field="name"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName="Cost"
                                            currentValue={
                                                this.state.routing.params
                                                    .order_by.cost
                                                    ? this.state.routing.params
                                                          .order_by.cost
                                                    : ""
                                            }
                                            field="cost"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName="Selling"
                                            currentValue={
                                                this.state.routing.params
                                                    .order_by.selling
                                                    ? this.state.routing.params
                                                          .order_by.selling
                                                    : ""
                                            }
                                            field="selling"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>
                                        In Stock
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Reserved
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Available
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map(i => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.type === 'Inventory' ? <Label color='green' size='mini'>Inventory</Label> : null}
                                            {i.type === 'Service' ? <Label color='pink' size='mini'>Service</Label> : null}
                                            {i.type === 'Others' ? <Label color='violet' size='mini'>Others</Label> : null}
                                        </Table.Cell>
                                        <Table.Cell>{i.sku}</Table.Cell>
                                        <Table.Cell>
                                            <Link to={`/inventories/${i.id}/view`}>
                                                {i.name}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {Math.round(i.cost * 100) / 100}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {Math.round(i.selling * 100) / 100}
                                        </Table.Cell>
                                        <Table.Cell>{i.status}</Table.Cell>
                                        <Table.Cell>{i.type === 'Inventory' ? this.getInstock(i) : "NA"}</Table.Cell>
                                        <Table.Cell>{i.type === 'Inventory' ? this.getReserved(i) : "NA"}</Table.Cell>
                                        <Table.Cell>{i.type === 'Inventory' ? this.getAvailable(i) : "NA"}</Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8" style={{marginTop: '5px'}}>
                        <TablePagination
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page}
                            total_records={list.total_count}
                            per_page={list.per_page} />
                    </div>
                    <div className="col-md-4" style={{marginTop: '5px'}}>
                        <div className="row">
                            <div className="col-md-8" style={{marginTop: '5px'}}>
                                <Form.Input
                                    fluid
                                    label="Randmar Shopify Product ID"
                                    name="sku"
                                    size='mini'
                                    value={this.state.shopifyProductId}
                                    onChange={(e) => { this.setState({shopifyProductId: e.target.value}) }}
                                />
                            </div>
                            <div className="col-md-4" style={{paddingTop: '25px'}}>
                                <Button
                                    color="teal"
                                    onClick={this.onImportRandmarClick}
                                    loading={this.state.loading}
                                    size='mini'
                                >
                                    Import
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12" style={{marginTop: '5px'}}>
                                <List>
                                    {this.state.randmarError.map(err => {
                                        return <List.Item key={err}>{err}</List.Item>
                                    })}
                                </List>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

InventoryListPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchInventories: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.inventory.list,
        warehouses: state.system.resources.warehouses
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchInventories
    }, dispatch);
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(InventoryListPage)
);



// WEBPACK FOOTER //
// ./src/components/inventories/InventoryList.js